import Card from 'core/card'
import React from 'react'
import BootstrapManagement from './components/BootstrapManagement'
import './index.scss'

export default function BootstrapComponent() {
  return (
    <div className="section bootstrap-page">
      <Card>
        <div className="bootstrap-content">
          <BootstrapManagement />
        </div>
      </Card>
    </div>
  )
}
